"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTemplateRow = exports.StyledTemplateContent = exports.StyledTemplateCol = exports.StyledTemplateCell = exports.StyledTemplateCaption = exports.StyledTemplateAvatarContent = exports.StyledTemplateAvatar = exports.StyledSelectionSelectedValue = exports.StyledSelectionRendered = exports.StyledSelectionPlaceholder = exports.StyledSelectionClear = exports.StyledSelectionChoiceRemove = exports.StyledSelectionChoiceContent = exports.StyledSelectionChoice = exports.StyledSelection = exports.StyledSelectTextVisibility = exports.StyledSelectDropdownTriggerContainer = exports.StyledSelectDropdownHeader = exports.StyledSelectDropdownFooter = exports.StyledSelectContentWrapper = exports.StyledSelect = exports.StyledSearchInlineLi = exports.StyledSearchInline = exports.StyledSearchFieldWrap = exports.StyledSearchFieldMirror = exports.StyledSearchField = exports.StyledCustomIcon = exports.StyledCheckIcon = exports.StyledArrow = exports.StyledAddonBefore = exports.StyledAddonAfter = exports.PrefixGlobalStyle = exports.ListboxItem = exports.Listbox = exports.ItemGroupTitle = exports.ItemGroupList = exports.CustomIconWrapper = exports.CopyIcon = exports.CopyButton = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _Button = _interopRequireDefault(require("../Button"));
var _StyledButton = _interopRequireDefault(require("../Button/StyledButton"));
var _Grid = require("../Grid");
var _Icon = _interopRequireDefault(require("../Icon"));
var _StyledIcon = _interopRequireDefault(require("../Icon/StyledIcon"));
var _StyledSpin = require("../Spin/StyledSpin");
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
var _Select = _interopRequireDefault(require("../ykb-styled-components/Globals/components/Select"));
var _excluded = ["children", "className", "prefixCls", "multiple"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var StyledArrow = exports.StyledArrow = (0, _ykbStyledComponents.default)(_Icon.default).withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-0"
})(["color:", " !important;pointer-events:none;user-select:none;font-size:", " !important;"], function (props) {
  return props.$theme.color.primary6;
}, function (props) {
  return props.$theme.select.icon.size;
});
var StyledCustomIcon = exports.StyledCustomIcon = (0, _ykbStyledComponents.default)(_Icon.default).withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-1"
})(["color:", " !important;pointer-events:none;user-select:none;font-size:", ";"], function (props) {
  return props.theme.color.primary6;
}, function (props) {
  return props.$theme.select.icon.size;
});
var CustomIconWrapper = exports.CustomIconWrapper = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-2"
})(["pointer-events:none;user-select:none;img{position:absolute;right:10px;transform:translateY(-50%);}"]);
var StyledSelectionChoice = exports.StyledSelectionChoice = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-3"
})(["&[class*='-disabled']{padding:0 10px;}"]);
var StyledSelectionChoiceContent = exports.StyledSelectionChoiceContent = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-4"
})([""]);
var StyledSelectionChoiceRemove = exports.StyledSelectionChoiceRemove = (0, _ykbStyledComponents.default)(_Icon.default).withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-5"
})([""]);
var StyledCheckIcon = exports.StyledCheckIcon = (0, _ykbStyledComponents.default)(_Icon.default).attrs(function () {
  return {
    className: 'ykb-ui-styled-check-icon'
  };
}).withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-6"
})(["&&{display:block;font-size:", ";transition:all 0.2s ease;position:absolute;top:50%;transform:translateY(-50%);right:", ";text-shadow:0 0.1px 0,0.1px 0 0,0 -0.1px 0,-0.1px 0;color:", ";}"], function (props) {
  return props.$theme.select.icon.size;
}, function (props) {
  return props.$theme.select.dropdownItemCheckIconRight;
}, function (props) {
  return props.$theme.color.primary6;
});
var placeholderMixin = (0, _ykbStyledComponents.css)(["position:absolute;top:50%;left:0;right:9px;color:", ";line-height:20px;height:20px;max-width:100%;margin-top:-10px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;text-align:left;"], function (props) {
  return props.theme.color.neutral7;
});
var StyledSearchFieldPlaceholder = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-7"
})(["", ";left:", ";"], placeholderMixin, function (props) {
  return props.theme.input.sizes.medium.paddingVertical;
});
var StyledSearchFieldMirror = exports.StyledSearchFieldMirror = _ykbStyledComponents.default.span.withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-8"
})(["position:absolute;top:-9999px;left:-9999px;white-space:pre;pointer-events:none;"]);
var StyledSearchFieldWrap = exports.StyledSearchFieldWrap = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-9"
})(["display:inline-block;position:relative;"]);
var StyledSearchField = exports.StyledSearchField = _ykbStyledComponents.default.input.withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-10"
})([""]);
var StyledSelectionPlaceholder = exports.StyledSelectionPlaceholder = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-11"
})(["", ";"], placeholderMixin);
var StyledSelectionRendered = exports.StyledSelectionRendered = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-12"
})(["display:block;margin-left:calc( ", " - 1px );margin-right:6px;position:relative;line-height:calc(", " - 2px);", " &:after{content:'.';visibility:hidden;pointer-events:none;display:inline-block;width:0;}"], function (props) {
  return props.theme.input.sizes.medium.paddingHorizontal;
}, function (props) {
  return props.theme.input.sizes.medium.height;
}, function (props) {
  return props.$single && (0, _ykbStyledComponents.css)(["display:flex;"]);
});
var iconfontMixin = (0, _ykbStyledComponents.css)(["display:inline-block;font-style:normal;vertical-align:", ";text-align:center;text-transform:none;line-height:1;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;&:before{display:block;font-family:'ykb-icon' !important;}"], function (props) {
  return props.$size === 'small' ? 'middle' : 'baseline';
});
var activeMixin = (0, _ykbStyledComponents.css)(["border-color:", ";outline:0;box-shadow:0 0 3px 3px ", ";border-right-width:1px !important;"], function (props) {
  return props.theme.color.primary6;
}, function (props) {
  return props.theme.input.focus.boxShadowColor;
});
var selectionClearMixin = (0, _ykbStyledComponents.css)(["display:inline-block;font-style:normal;vertical-align:baseline;text-align:center;text-transform:none;text-rendering:auto;opacity:0;position:absolute;right:", ";z-index:1;background:", ";top:50%;font-size:", "px;color:", ";width:", "px;height:", "px;line-height:", "px;cursor:pointer;transition:color 0.3s ease,opacity 0.15s ease;&:hover{color:", ";}"], function (props) {
  return props.$theme.select.icon.right;
}, function (props) {
  return props.$theme.input.backgroundColor;
}, function (props) {
  return props.$theme.select.clear.iconSize;
}, function (props) {
  return props.$theme.icon.type.default.color;
}, function (props) {
  return props.$theme.select.clear.iconSize;
}, function (props) {
  return props.$theme.select.clear.iconSize;
}, function (props) {
  return props.$theme.select.clear.iconSize;
}, function (props) {
  return props.$theme.icon.type.default.hoverColor;
});
var clearFixMixin = (0, _ykbStyledComponents.css)(["*zoom:1;&:before,&:after{display:table;line-height:0;content:'';}&:after{clear:both;}"]);
var StyledSearchInline = exports.StyledSearchInline = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-13"
})(["position:absolute;height:100%;width:100%;", "{height:100%;width:100%;}", "{border-width:0;font-size:100%;width:100%;background:transparent;outline:0;border-radius:", ";line-height:1;caret-color:transparent;&::-ms-clear{display:none;}}> i{float:right;}"], StyledSearchFieldWrap, StyledSearchField, function (props) {
  return props.theme.borderRadiusBase;
});
var StyledSearchInlineLi = exports.StyledSearchInlineLi = StyledSearchInline.withComponent('li');
var StyledSelection = exports.StyledSelection = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-14"
})(["outline:none;user-select:none;box-sizing:border-box;display:block;background-color:", ";border-radius:", ";border:", " ", " ", ";transition:all 0.3s ", ";&:hover{border-color:", ";}&:focus,&:active{", ";}", ";", ""], function (props) {
  return props.theme.input.backgroundColor;
}, function (props) {
  return props.theme.borderRadiusBase;
}, function (props) {
  return props.theme.border.width;
}, function (props) {
  return props.theme.border.style;
}, function (props) {
  return props.theme.border.colorBase;
}, function (props) {
  return props.theme.animation.ease.inOut;
}, function (props) {
  return props.theme.input.hover.borderColor;
}, activeMixin, function (props) {
  return props.copyable && (0, _ykbStyledComponents.css)(["width:calc(100% - 40px);border-top-right-radius:0;border-bottom-right-radius:0;border-right:0;"]);
}, function (props) {
  return props.$multiple ? (0, _ykbStyledComponents.css)(["min-height:", ";cursor:text;padding-bottom:0px;", ";", "{float:left;position:static;width:auto;padding:0;max-width:100%;}", "{float:left;position:static;width:auto;padding:0;margin-left:6px;letter-spacing:0.2em;max-width:100%;}", "{margin:0;padding:0;background:0 0;border:none;outline:none;min-width:4.1px;}", "{margin-left:4px;margin-bottom:-3px;height:auto;}", "{margin-left:6px;}", "{margin-top:4px;height:calc( ", " - 10px );line-height:calc( ", " - 8px - 2px );", " ", " padding-left:6px;", "{margin-right:4px;}}", "{color:", ";background-color:", ";border:1px solid ", ";border-radius:", ";cursor:default;float:left;margin-right:4px;max-width:99%;position:relative;overflow:hidden;transition:padding 0.3s ", ";padding:0 22px 0 10px;}", "{display:inline-block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:100%;transition:margin 0.3s ", ";", "{position:sticky;top:50%;}}", "{", ";color:", ";line-height:inherit;cursor:pointer;display:inline-block;font-weight:bold;transition:all 0.3s;font-size:", ";position:absolute;right:4px;top:50%;transform:translateY(-50%);&:hover{color:", ";}}", "{top:calc(", " / 2);}&[class*='-disabled']{", "{background:", ";color:", ";padding-right:10px;", "{display:none;}}}"], function (props) {
    return props.theme.input.sizes.medium.height;
  }, clearFixMixin, StyledSearchInlineLi, StyledSearchInline, StyledSearchField, StyledSelectionRendered, StyledSelectionPlaceholder, StyledSelectionChoice, function (props) {
    return props.theme.input.sizes.medium.height;
  }, function (props) {
    return props.theme.input.sizes.medium.height;
  }, function (props) {
    return props.$size === 'small' && (0, _ykbStyledComponents.css)(["height:calc( ", " - 10px );line-height:calc( ", " - 8px - 2px );"], function (props) {
      return props.theme.input.sizes.small.height;
    }, function (props) {
      return props.theme.input.sizes.small.height;
    });
  }, function (props) {
    return props.$size === 'large' && (0, _ykbStyledComponents.css)(["height:calc( ", " - 10px );line-height:calc( ", " - 8px - 2px );"], function (props) {
      return props.theme.input.sizes.large.height;
    }, function (props) {
      return props.theme.input.sizes.large.height;
    });
  }, StyledSelectionChoiceContent, StyledSelectionChoice, function (props) {
    return props.theme.text.color;
  }, function (props) {
    return props.theme.colorPalette.grey1;
  }, function (props) {
    return props.theme.select.tagBorderColor;
  }, function (props) {
    return props.theme.borderRadiusSm;
  }, function (props) {
    return props.theme.animation.ease.inOut;
  }, StyledSelectionChoiceContent, function (props) {
    return props.theme.animation.ease.inOut;
  }, _StyledIcon.default, StyledSelectionChoiceRemove, iconfontMixin, function (props) {
    return props.theme.icon.type.default.color;
  }, function (props) {
    return props.theme.font.sizeSm;
  }, function (props) {
    return props.theme.icon.type.default.hoverColor;
  }, StyledSelectionClear, function (props) {
    return props.theme.input.sizes.medium.height;
  }, StyledSelectionChoice, function (props) {
    return props.theme.input.disabled.backgroundColor;
  }, function (props) {
    return props.theme.color.neutral6;
  }, StyledSelectionChoiceRemove) : (0, _ykbStyledComponents.css)(["height:unset;position:relative;cursor:pointer;", " ", ""], function (props) {
    return props.$multiline && (0, _ykbStyledComponents.css)(["height:", ";", "{float:left;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;max-width:100%;padding-right:20px;width:100%;white-space:break-spaces;}", "{height:", ";line-height:calc( ", " / 2 );", "{top:15%;}}"], function (props) {
      return props.theme.select.multilineHeight;
    }, StyledSelectionSelectedValue, StyledSelectionRendered, function (props) {
      return props.theme.select.multilineHeight;
    }, function (props) {
      return props.theme.select.multilineHeight;
    }, _StyledIcon.default);
  }, function (props) {
    return props.$template && (0, _ykbStyledComponents.css)(["height:unset !important;min-height:40px;", "{display:flex;max-width:100%;width:calc(100% - 40px);min-height:40px;&:after{display:none;}", "{margin-left:0px;margin-right:0px;}", "{width:100%;padding-right:0px;}}", "{min-width:100px;}", "{min-height:24px;}"], StyledSelectionRendered, StyledTemplateRow, StyledSelectionSelectedValue, StyledSelectionPlaceholder, StyledSearchField);
  });
});
var StyledSelectionClear = exports.StyledSelectionClear = (0, _ykbStyledComponents.default)(_Icon.default).withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-15"
})(["", ";line-height:0;"], selectionClearMixin);
var StyledSelectionSelectedValue = exports.StyledSelectionSelectedValue = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-16"
})(["", " float:left;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%;padding-right:20px;width:100%;", "{position:relative;top:25%;}z-index:1;"], function (props) {
  return props.$open && props.$showSearch && (0, _ykbStyledComponents.css)(["display:none;"]);
}, _StyledIcon.default);
var Listbox = exports.Listbox = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-17"
})(["margin:0;padding:0;list-style:none;z-index:9999;max-height:250px;overflow:auto;font-size:14px !important;box-shadow:0px 2px 10px 0px rgba(0,0,0,0.1);padding:", ";", ""], function (props) {
  return props.theme.select.dropdownInnerPadding;
}, function (props) {
  return props.$hideShadow && (0, _ykbStyledComponents.css)(["box-shadow:none;"]);
});
var ItemGroupList = exports.ItemGroupList = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-18"
})(["margin:0;padding:0;> [role='option']{padding-left:20px;}"]);
var ItemGroupTitle = exports.ItemGroupTitle = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-19"
})(["color:", ";padding:0px ", ";height:", ";line-height:", ";font-size:", ";font-weight:500;cursor:default;"], function (props) {
  return props.theme.select.optGroupTitleColor;
}, function (props) {
  return props.theme.input.sizes.medium.paddingHorizontal;
}, function (props) {
  return props.theme.input.sizes.small.height;
}, function (props) {
  return props.theme.input.sizes.small.height;
}, function (props) {
  return props.theme.font.sizeSm;
});
var ListboxItem = exports.ListboxItem = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-20"
})(["position:relative;display:block;padding:", ";line-height:", ";font-weight:normal;color:", ";white-space:nowrap;cursor:pointer;overflow:hidden;text-overflow:ellipsis;transition:background 0.3s ease;.content{padding-right:36px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}&:focus,&:hover{background-color:", ";outline:none;}&:active{background-color:", ";}&[class*='-grouped']{padding-left:20px;}&[class*='-disabled']{color:", ";cursor:not-allowed;&:hover{color:", ";background-color:", ";cursor:not-allowed;}}&[class*='-selected']{", " .content{text-overflow:ellipsis;overflow:hidden;}background-color:", ";&:hover{background-color:", ";color:", ";}}&[class*='-active']{background-color:", ";}.divider{height:1px;margin:1px 0;overflow:hidden;background-color:", ";line-height:0;}", "{margin-top:0px;}", " ", ""], function (props) {
  return props.theme.select.dropdownItemPadding;
}, function (props) {
  return props.theme.select.dropdownLineHeight;
}, function (props) {
  return props.theme.text.color;
}, function (props) {
  return props.theme.select.optHoverBg;
}, function (props) {
  return props.theme.select.optSelectBg;
}, function (props) {
  return props.theme.text.colorDisabled;
}, function (props) {
  return props.theme.text.colorDisabled;
}, function (props) {
  return props.theme.input.backgroundColor;
}, function (props) {
  return props.hideSelectedOptions && (0, _ykbStyledComponents.css)(["height:0;padding:0;margin:0;overflow:hidden;visibility:hidden;"]);
}, function (props) {
  return props.theme.select.optSelectBg;
}, function (props) {
  return props.theme.select.optHoverBg;
}, function (props) {
  return props.theme.text.color;
}, function (props) {
  return props.theme.select.optHoverBg;
}, function (props) {
  return props.theme.border.colorBase;
}, _StyledSpin.StyledSpinWrap, function (props) {
  return props.$template && (0, _ykbStyledComponents.css)(["&:nth-child(odd){background-color:", ";}&:hover{background-color:", ";}"], function (props) {
    return props.theme.colorPalette.grey1;
  }, function (props) {
    return props.theme.colorPalette.grey2;
  });
}, function (props) {
  return props.$empty && (0, _ykbStyledComponents.css)(["pointer-events:none;"]);
});
var StyledSelectDropdownFooter = exports.StyledSelectDropdownFooter = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-21"
})(["padding:7px 0px;border-top:1px solid #ccc;display:flex;justify-content:flex-end;", "{margin-bottom:0px;}"], _StyledButton.default);
var StyledSelectDropdownHeader = exports.StyledSelectDropdownHeader = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-22"
})(["padding:7px 10px;border-bottom:1px solid #ccc;display:flex;", "{margin-bottom:0px;}"], _StyledButton.default);
var PrefixGlobalStyle = exports.PrefixGlobalStyle = (0, _ykbStyledComponents.createGlobalStyle)(["", ""], function (props) {
  return (0, _Select.default)(props);
});
var StyledSelectDropdownTriggerContainer = exports.StyledSelectDropdownTriggerContainer = (0, _ykbStyledComponents.default)(function (_ref) {
  var children = _ref.children,
    className = _ref.className,
    prefixCls = _ref.prefixCls,
    multiple = _ref.multiple,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var prefix = prefixCls;
  prefix = "".concat(prefix, "-dropdown");
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, children(prefix), prefixCls !== 'ykb-ui-select' && /*#__PURE__*/_react.default.createElement(PrefixGlobalStyle, {
    prefixCls: prefixCls,
    theme: rest.theme
  }));
}).withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-23"
})([""]);
var StyledSelect = exports.StyledSelect = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-24"
})(["display:block;position:relative;width:100%;min-width:40px;color:", ";ul,ol{margin:0;padding:0;list-style:none;}> ul > li > a{padding:0;background-color:", ";}", "{", ";line-height:0;transform:translateY(-50%);transform-origin:50% 50%;transition:transform 0.2s ease;}", ";&:hover{", "{opacity:1;}}&.showCursor{", "{caret-color:#000000;}}&.focused{", "{", ";}", "{opacity:1;pointer-events:auto;display:inline-block;}}&[class*='-disabled']{color:", ";cursor:not-allowed;", "{color:", ";}", "{background:", ";pointer-events:none;&:hover,&:focus,&:active{border-color:", ";box-shadow:none;}", "{display:none;visibility:hidden;pointer-events:none;}}", "{color:", ";cursor:default;&:hover{color:", ";}}}@media (max-width:992px){", "{display:none;pointer-events:none;}}", " ", " ", " ", " ", " ", "    "], function (props) {
  return props.theme.text.color;
}, function (props) {
  return props.theme.input.backgroundColor;
}, _StyledIcon.default, iconfontMixin, function (props) {
  return props.copyable && (0, _ykbStyledComponents.css)(["display:flex;", "{right:44px;}"], _StyledIcon.default);
}, StyledSelectionClear, StyledSearchField, StyledSelection, activeMixin, StyledSelectionClear, function (props) {
  return props.theme.text.colorDisabled;
}, StyledArrow, function (props) {
  return props.theme.text.colorDisabled;
}, StyledSelection, function (props) {
  return props.theme.input.disabled.backgroundColor;
}, function (props) {
  return props.theme.border.colorBase;
}, StyledSelectionClear, StyledSelectionChoiceRemove, function (props) {
  return props.theme.colorPalette.grey6;
}, function (props) {
  return props.theme.colorPalette.grey6;
}, StyledSelectionClear, function (props) {
  return props.$size === 'large' && (0, _ykbStyledComponents.css)(["font-size:", ";", "{line-height:calc( ", " - 2px );margin-right:8px;}", ""], function (props) {
    return props.theme.font.sizeLg;
  }, StyledSelectionRendered, function (props) {
    return props.theme.input.sizes.large.height;
  }, function (props) {
    return props.$multiple ? (0, _ykbStyledComponents.css)(["min-height:", ";", "{li{height:calc(", " - 8px);line-height:calc(", " - 8px);}", "{top:calc( ", " / 2 );}"], function (props) {
      return props.theme.input.sizes.large.height;
    }, StyledSelectionRendered, function (props) {
      return props.theme.input.sizes.large.height;
    }, function (props) {
      return props.theme.input.sizes.large.height;
    }, StyledSelectionClear, function (props) {
      return props.theme.input.sizes.large.height;
    }) : (0, _ykbStyledComponents.css)(["", "{height:", ";}"], StyledSelection, function (props) {
      return props.theme.input.sizes.large.height;
    });
  });
}, function (props) {
  return props.$size === 'small' && (0, _ykbStyledComponents.css)(["", "{min-height:", ";}", "{line-height:calc( ", " - 2px );margin-right:5px;}", ""], StyledSelection, function (props) {
    return props.theme.input.sizes.small.height;
  }, StyledSelectionRendered, function (props) {
    return props.theme.input.sizes.small.height;
  }, function (props) {
    return props.$multiple ? (0, _ykbStyledComponents.css)(["min-height:", ";", "{li{height:calc(", " - 8px);line-height:calc(", " - 10px);}", "{top:calc( ", " / 2 );}"], function (props) {
      return props.theme.input.sizes.small.height;
    }, StyledSelectionRendered, function (props) {
      return props.theme.input.sizes.small.height;
    }, function (props) {
      return props.theme.input.sizes.small.height;
    }, StyledSelectionClear, function (props) {
      return props.theme.input.sizes.small.height;
    }) : (0, _ykbStyledComponents.css)(["height:", ";"], function (props) {
      return props.theme.input.sizes.small.height;
    });
  });
}, function (props) {
  return !!props.$allowClear && props.$multiple && (0, _ykbStyledComponents.css)(["", "{margin-right:20px;}"], StyledSelectionRendered);
}, function (props) {
  return props.$open && (0, _ykbStyledComponents.css)(["", "{transform:translateY(-50%) rotate(180deg);}", "{", ";}"], StyledArrow, StyledSelection, activeMixin);
}, function (props) {
  return props.$combobox && (0, _ykbStyledComponents.css)(["", "{display:none;}", "{display:none;}", "{display:none;}", "{height:100%;width:100%;float:none;}", "{height:100%;width:100%;}", "{width:100%;height:100%;position:relative;z-index:1;transition:all 0.3s ", ";box-shadow:none;}"], StyledArrow, StyledCustomIcon, CustomIconWrapper, StyledSearchInline, StyledSearchFieldWrap, StyledSearchField, function (props) {
    return props.theme.animation.ease.inOut;
  });
}, function (props) {
  return props.$combobox && !!props.$allowClear && (0, _ykbStyledComponents.css)(["", "{&:hover{", "{margin-right:20px;}}}"], StyledSelection, StyledSelectionRendered);
});
var StyledSelectTextVisibility = exports.StyledSelectTextVisibility = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-25"
})(["width:0;height:0;display:'flex';overflow:'hidden';opacity:0;"]);
var StyledSelectContentWrapper = exports.StyledSelectContentWrapper = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-26"
})(["display:flex;justify-content:space-between;align-items:center;position:relative;.SelectTriggerWrapper{position:relative;display:flex;align-items:center;width:100%;.ykb-ui-select-selector{", " width:100%;", " ", " ", " & + span.ykb-icon{", "}}> .", "-selector{width:100%;min-width:40px;", "}> ", "{position:absolute;top:50%;right:", ";", "}}"], function (props) {
  return props.$backgroundColorType && (0, _ykbStyledComponents.css)(["background-color:", ";"], props.$backgroundColorType === 'primary' ? props.theme.color.primary1 : props.$backgroundColorType === 'danger' ? props.theme.color.danger1 : props.theme.color.neutral1);
}, function (props) {
  return props.$copyable && (0, _ykbStyledComponents.css)(["border-top-right-radius:0;border-bottom-right-radius:0;border-right:0;"]);
}, function (props) {
  return props.type === 'addon' && props.addonAfter && (0, _ykbStyledComponents.css)(["border-top-right-radius:0;border-bottom-right-radius:0;border-right:0;"]);
}, function (props) {
  return props.type === 'addon' && props.addonBefore && (0, _ykbStyledComponents.css)(["border-top-left-radius:0;border-bottom-left-radius:0;border-left:0;"]);
}, function (props) {
  return props.$copyable && (0, _ykbStyledComponents.css)(["right:", ";"], props.$size === 'small' ? '36px' : props.$size === 'large' ? '56px' : '46px');
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return (props.mode == 'multiple' || props.mode == 'tags') && (0, _ykbStyledComponents.css)(["max-height:180px;overflow-y:auto;"]);
}, _StyledIcon.default, function (props) {
  return props.theme.select.icon.right;
}, function (props) {
  return props.$copyable && (0, _ykbStyledComponents.css)(["right:", ";"], props.$size === 'small' ? props.theme.select.icon.rightForSmall : props.$size === 'large' ? props.theme.select.icon.rightForLarge : props.theme.select.icon.rightForMedium);
});
var StyledTemplateCaption = exports.StyledTemplateCaption = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-27"
})(["height:17px;line-height:17px;", " ", " ", ""], function (props) {
  return props.$index === 0 && (0, _ykbStyledComponents.css)(["font-size:13px;font-weight:", ";"], props.$viewMode ? 'normal' : '500');
}, function (props) {
  return props.$index === 1 && (0, _ykbStyledComponents.css)(["font-size:12px;font-weight:500;"]);
}, function (props) {
  return props.$index === 2 && (0, _ykbStyledComponents.css)(["font-size:12px;font-weight:", ";"], props.$viewMode ? '500' : 'normal');
});
var StyledTemplateCell = exports.StyledTemplateCell = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-28"
})(["overflow:hidden;text-overflow:ellipsis;white-space:nowrap;", " ", ""], function (props) {
  return props.$header && (0, _ykbStyledComponents.css)(["font-size:13px;font-weight:", ";"], props.$viewMode ? 'normal' : '500');
}, function (props) {
  return props.$text && (0, _ykbStyledComponents.css)(["font-size:13px;font-weight:", ";"], props.$viewMode ? '500' : 'normal');
});
var StyledTemplateCol = exports.StyledTemplateCol = (0, _ykbStyledComponents.default)(_Grid.Col).withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-29"
})(["padding-left:0px;padding-right:0px;"]);
var StyledTemplateRow = exports.StyledTemplateRow = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-30"
})(["margin:5px 10px 4px 0px;line-height:24px;height:51px;display:flex;align-items:center;", "{padding-left:0px;}@media (max-width:1200px){height:100%;margin:8px 10px;}"], StyledTemplateCol);
var StyledTemplateAvatar = exports.StyledTemplateAvatar = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-31"
})(["width:60px;float:left;height:100%;display:flex;align-items:center;"]);
var StyledTemplateAvatarContent = exports.StyledTemplateAvatarContent = _ykbStyledComponents.default.img.withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-32"
})(["width:50px;height:34px;"]);
var StyledTemplateContent = exports.StyledTemplateContent = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-33"
})(["width:calc(100% - 60px);float:left;"]);
var CopyButton = exports.CopyButton = (0, _ykbStyledComponents.default)(_Button.default).withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-34"
})(["width:", ";background-color:", " !important;border:none !important;margin:0 !important;border-top-left-radius:0 !important;border-bottom-left-radius:0 !important;cursor:pointer;&:hover,&:active{background-color:", " !important;}&:active{transform:scale(0.95);}"], function (props) {
  return props.theme.select.copyable.button.width[props.size];
}, function (props) {
  return props.theme.color.primary6;
}, function (props) {
  return props.theme.color.primary7;
});
var CopyIcon = exports.CopyIcon = (0, _ykbStyledComponents.default)(_Icon.default).withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-35"
})(["position:absolute;font-size:", ";right:", ";"], function (props) {
  return props.theme.select.copyable.icon.size[props.$size];
}, function (props) {
  return props.theme.select.copyable.icon.right[props.$size];
});
var StyledAddonAfter = exports.StyledAddonAfter = _ykbStyledComponents.default.span.withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-36"
})(["> span,.icon-wrapper > span{transform:none !important;}", " ", " > *{border:0px;margin:-1px -12px -1px -10px;}", "{border-radius:", ";padding:0 ", ";}"], function (props) {
  return props.type == 'addon' && props.addonAfter && (0, _ykbStyledComponents.css)(["padding:0 ", ";border-radius:", ";font-size:", ";min-height:", ";justify-content:center;align-items:center;display:flex;color:", ";text-align:center;background-color:", ";border:", ";position:relative;"], function (props) {
    return props.theme.select.addon.padding;
  }, function (props) {
    return props.theme.select.addon.borderRadiusAfter;
  }, function (props) {
    return props.theme.select.addon.fontSize;
  }, props.size === 'small' ? props.theme.select.copyable.button.height.small : props.size === 'large' ? props.theme.select.copyable.button.height.large : props.theme.select.copyable.button.height.medium, function (props) {
    return props.theme.color.neutral11;
  }, function (props) {
    return props.transparentAddons ? 'transparent' : props.theme.input.addon.backgroundColor;
  }, function (props) {
    return props.theme.select.addon.border;
  });
}, function (props) {
  return props.type == 'addon' && props.addonAfter && (0, _ykbStyledComponents.css)(["", "{height:", ";}"], _StyledButton.default, props.size === 'small' ? props.theme.select.copyable.button.height.small : props.size === 'large' ? props.theme.select.copyable.button.height.large : props.theme.select.copyable.button.height.medium);
}, _StyledButton.default, function (props) {
  return props.theme.select.addon.borderRadiusAfter;
}, function (props) {
  return props.theme.select.addon.padding;
});
var StyledAddonBefore = exports.StyledAddonBefore = _ykbStyledComponents.default.span.withConfig({
  componentId: "ykb-ui__sc-1bv7wyp-37"
})(["> span,.icon-wrapper > span{transform:none !important;}", " ", " > *{border:0px;margin:-1px -12px -1px -10px;}", "{border-radius:", ";padding:0 ", ";}"], function (props) {
  return props.type == 'addon' && props.addonBefore && (0, _ykbStyledComponents.css)(["padding:0 ", ";border-radius:", ";font-size:", ";min-height:", ";justify-content:center;align-items:center;display:flex;color:", ";text-align:center;background-color:", ";border:", ";position:relative;"], function (props) {
    return props.theme.select.addon.padding;
  }, function (props) {
    return props.theme.select.addon.borderRadiusBefore;
  }, function (props) {
    return props.theme.select.addon.fontSize;
  }, props.size === 'small' ? props.theme.select.copyable.button.height.small : props.size === 'large' ? props.theme.select.copyable.button.height.large : props.theme.select.copyable.button.height.medium, function (props) {
    return props.theme.color.neutral11;
  }, function (props) {
    return props.transparentAddons ? 'transparent' : props.theme.input.addon.backgroundColor;
  }, function (props) {
    return props.theme.select.addon.border;
  });
}, function (props) {
  return props.type == 'addon' && props.addonBefore && (0, _ykbStyledComponents.css)(["", "{height:", ";}"], _StyledButton.default, props.size === 'small' ? props.theme.select.copyable.button.height.small : props.size === 'large' ? props.theme.select.copyable.button.height.large : props.theme.select.copyable.button.height.medium);
}, _StyledButton.default, function (props) {
  return props.theme.select.addon.borderRadiusBefore;
}, function (props) {
  return props.theme.select.addon.padding;
});